import _ from 'lodash-es';
import Defaults from '~/scripts/constants/defaults';
import blank from '~/images/blank.gif';
import { langToFlag } from '~/utils/locales';
import Utils from '~/scripts/services/utils';
import APIV5 from '~/models/api';
import { UAParser } from 'ua-parser-js';
import templateNewVersion from './new-version.html';

/* globals Knitiv */

export default class MainController {
	/**
	 *
	 * @param {import('angular').IIntervalService} $interval
	 * @param {import('angular').ILocationService} $location
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {Knitiv.Scope} $scope
	 * @param {import('angular').ITemplateCacheService} $templateCache
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').IWindowService} $window
	 * @param {*} Notification
	 * @param {import('angular').route.IRouteService} $route
	 */
	/* @ngInject */
	constructor(
		$interval,
		$location,
		$rootScope,
		$scope,
		$templateCache,
		$timeout,
		$translate,
		$window,
		Notification,
		$route,
	) {
		this.$interval = $interval;
		this.$location = $location;
		this.$rootScope = $rootScope;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.Notification = Notification;

		/** @type {any} */
		this.bodyStyle = {};

		/** @type {?string} */
		this.currentTag = null;

		/** @type {import('angular').IPromise<any>|undefined} */
		this.intervalStop = undefined;

		/** @type {Array<any>} */
		const history = [];

		this.blank = blank;

		$rootScope.$watch(() => $rootScope.appConfig, () => {
			this.bodyStyle = {};

			if ($rootScope.path === 'login') {
				// @ts-ignore
				if ($rootScope.appConfig?.login?.page?.background?.url) {
					// @ts-ignore
					this.bodyStyle['background-image'] = `url(${$rootScope.appConfig?.login?.page?.background.url})`;
				}

				// @ts-ignore
				if ($rootScope.appConfig?.login?.page?.background?.position) {
					// eslint-disable-next-line max-len
					this.bodyStyle['background-position'] = `${
						// @ts-ignore
						$rootScope.appConfig?.login?.page?.background?.position?.horizontal ?? 'auto'
						// @ts-ignore
					} ${$rootScope.appConfig?.login?.page?.background?.position?.vertical ?? 'auto'}`;
				}
			}
		});

		$rootScope.waiting = false;
		$rootScope.displayMemoryStats = false;

		// console.log('process.env.TAG', process.env.TAG);

		$rootScope.tag = process.env.TAG ?? 'dev';

		$rootScope.$on('$routeChangeSuccess', () => {
			// @ts-ignore
			$rootScope.title = $route.current.title;
		});

		$rootScope.$on('$routeChangeError', (event, current, previous, rejection) => {
			console.error(event, current, previous, rejection);
		});

		$rootScope.goToPreviousURL = () => {
			let url = '';
			let index = history.length - 2;
			const search = $location.search();

			if ('error' in search && $rootScope.context) {
				while (!url && index >= 0) {
					if (
						_.isEqual(history[index].database, $rootScope.context.db.kid)
						&& history[index].user === $rootScope.context.profil.kid
					) {
						({ url } = history[index]);
						history.splice(index, 1);
					}
					index -= 1;
				}
				delete search.error;
			}
			else if ($rootScope.redirectTo) {
				url = $rootScope.redirectTo;
				$rootScope.redirectTo = undefined;
			}
			else if ('redirectTo' in search) {
				url = search.redirectTo;
			}

			if (!url) {
				url = '/';
			}

			$location.url(url);
		};

		if (process.env.NODE_ENV === 'production') {
			this.intervalStop = this.$interval(
				() => this.compareTags(),
				Defaults.checkIntervalForNewVersion * 1000,
			);
		}

		$rootScope.$on('$locationChangeSuccess', () => {
			// @ts-ignore
			let name = $route?.current?.$$route?.name;
			if (!name) {
				name = $location.path().split('/')?.[1];
			}

			$rootScope.path = name;

			APIV5.instance.setFrontURL($location.url());
		});

		$rootScope.reloadApp = () => {
			this.$location.search('v', this.currentTag || Utils.guid());
			$window.location.replace(this.$location.url());
		};

		this.langToFlag = langToFlag;
	}

	async $onInit() {
		const parser = new UAParser(navigator.userAgent);
		/** @type {UAParser.IDevice} */
		// @ts-ignore
		const device = await parser.getDevice().withClientHints();

		// @ts-ignore
		this.$rootScope.deviceType = device.type ?? 'desktop';
	}

	async compareTags() {
		const request = await fetch('/version');
		const data = await request.text();
		this.currentTag = data.trim();

		if (this.$rootScope.tag !== this.currentTag && typeof this.intervalStop?.then === 'function') {
			this.$interval.cancel(this.intervalStop);
			this.Notification.primary({
				title:          this.$translate.instant('common.info'),
				message:        this.$translate.instant('user.new-available-version'),
				template:       templateNewVersion,
				replaceMessage: true,
				// eslint-disable-next-line unicorn/no-null
				delay:          null,
			});
		}
	}
}
